<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <van-list
      v-model="loading"
      :finished="finished"
      :offset="offset"
      :immediate-check="ischeck"
      finished-text="没有更多了"
      @load="loadMore"
    >
      <div v-for="item in dataList" :key="item.SerialNumber">
        <div v-if="item.DeceasedInformationApiModelList.length > 1">
          <!-- 双人馆 -->
          <router-link
            :to="'/MemorialHall?id=' + item.SerialNumber"
            class="follow-item"
          >
            <div class="follow-list">
              <div class="ft">
                <van-swipe
                  class="my-swipe"
                  :loop="false"
                  indicator-color="orange"
                >
                  <van-swipe-item
                    v-for="clientitem in item.DeceasedInformationApiModelList"
                    :key="clientitem.id"
                  >
                    <img
                      :src="item.DeceasedInformationApiModelList[0].HeadPhoto"
                      class="avatar"
                    />
                  </van-swipe-item>
                </van-swipe>
              </div>
              <div class="bd">
                <h2 class="sz-name">{{ item.Title }}</h2>
                <div class="sz-des">
                  <van-button
                    size="small"
                    class="mybtn"
                    @click.prevent="clickCancleFollow(item.MemorialHallID)"
                    >取消关注</van-button
                  >
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div v-else>
          <!-- 单人馆 -->
          <router-link
            :to="'/MemorialHall?id=' + item.SerialNumber"
            class="follow-item"
          >
            <div class="follow-list">
              <div class="ft">
                <img
                  :src="item.DeceasedInformationApiModelList[0].HeadPhoto"
                  class="avatar"
                />
              </div>
              <div class="bd">
                <h2 class="sz-name">{{ item.Title }}</h2>
                <div class="sz-des">
                  <van-button
                    size="small"
                    class="mybtn"
                    @click.prevent="clickCancleFollow(item.MemorialHallID)"
                    >取消关注</van-button
                  >
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</template>

<script>
import { Toast } from "vant";
import { mapGetters, mapState } from "vuex";
export default {
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      refreshing: false,
      loading: true,
      finished: false,
      offset: 100,
      ischeck: false,
      options: null,
      dataList: [],
    };
  },
  computed: {},
  methods: {
    init() {
      var that = this;
      that.options = {
        type: "MyMemorialHallSearch",
        readMHType: that.appEnum.ReadMHType.Follow,
        pageIndex: 1,
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1,
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1,
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        (res) => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          if (res.MemorialHallSearchApiModelList.length <= 0) {
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (res.MemorialHallSearchApiModelList.length > 0) {
              res.MemorialHallSearchApiModelList.forEach((element) => {
                that.dataList.push(element);
              });
            }
          } else {
            that.dataList = res.MemorialHallSearchApiModelList;
          }
        },
        (error) => {}
      );
    },
    clickCancleFollow(mid) {
      //addFollowMemorialHall
      var that = this;
      this.$store
        .dispatch({
          type: "addFollowMemorialHallVue",
          IsAuth: true,
          MId: mid,
        })
        .then(
          (res) => {
            console.log(res);
            Toast(res.Message);
            if (res.IsSuccess) {
              that.onRefresh();
            }
          },
          (error) => {}
        );
    },
  },
  created() {
    var that = this;
    that.init();
  },
};
</script>

<style></style>
